// ATTN we use these constants in data dump
const abTests = {
  // CRO tests
  paymentQueueEditPopup: 'payment:queueEditPopup', // CRO-338
  paymentStickyPayButton: 'payment:stickyPayButton', // CRO-306
  paymentPriceWithDiscount: 'payment:priceWithDiscount', // CRO-347
  homeNewHowItWorks: 'home:newHowItWorks', // CRO-189
  homeHowItWorksWithAnimations: 'home:howItWorksWithAnimations', // CRO-374
  homeHeroVialCaseImage: 'home:heroVialCaseImage', // CRO-377
  tyHideAddedProduct: 'ty:hideAddedProduct', // CRO-270
  tyIterateCustomDesign: 'ty:iterateCustomDesign', // CRO-371
  queueNavBanner: 'queue:navBanner', // CRO-344
  caseShopHeroBanner: 'case:shopHeroBanner', // CRO-287
  candleDiscountBadge: 'candle:discountBadgeRelaunch', // CRO-312
  inviteDesignUpdate: 'invite:designUpdate', // CRO-370
  // EP tests
  queueStickyBanner: 'queue:stickyBanner', // EP-2100
  queueCaseSubscriptionBanner: 'queue:CaseSubscriptionBanner', // EP-2123
  cancelButton: 'cancelButton25', // EP-2144
  csBadge: 'cs:badge', // EP-2219
  burgerMenu: 'burgerMenu', // EP-2241
  homeCanada50vs60: 'home:canada50vs60', // EP-2181
  upgradeEntryPoints: 'upgradeEntryPoints', // EP-2237
  burgerMenuBannersForLeads: 'burgerMenuBannersForLeads', // EP-2242
  burgerMenuBannersForActive: 'burgerMenuBannersForActive', // EP-2242
  upgradePopup: 'upgradePopup', // EP-2262
  navScentHoroscopeInPerfumes: 'nav:scentHoroscopeInPerfumes', // EP-2364
  caseUpsellOptions12vs3: 'caseUpsellOptions12vs3', // EP-2419
  // PF tests
  upchargeInfoPayment: 'UpchargeInfoPayment', // PF-1397
  driftbrandpage: 'driftbrandpage', // PF-1766
  limitedDropsCheckoutRedirect: 'limitedDropsCheckoutRedirect', // PF-2107
  recommendedForYouNavLink: 'nav:recommendedForYouNavLink', // PF-2295
  theValentinesEdit: 'theValentinesEdit', // PF-2316
  theLuxeEdit: 'theLuxeEditV2', // PF-2354
  queueDragTooltip: 'queueDragTooltip', // PF-2299
  constructorRecommendations: 'constructorRecommendations', // PF-2319
  spCancelAnytimeBadge: 'sp:cancelAnytimeBadge', // PF-2797
} as const

export type AbTestName = typeof abTests[keyof typeof abTests]


export default abTests
